import Component from '../abstracts/Component';

export default class TabsComponent extends Component {

  get COMPONENTNAME() {
    return 'TabsComponent';
  }

  get SELECTORS() {
    return {
      container: '[data-pdp-info-tabs]',
      trigger: '[data-trigger]',
      content: '[data-tab]',
    };
  }

  get CLASSES() {
    return {
      hidden: 'hidden',
      active: 'active'
    };
  }

  constructor(compEl) {
    super(compEl);
  }

  readDOM() {
    return {
      container: this.$component.querySelector(this.SELECTORS.container),
      triggers: [...this.$component.querySelectorAll(this.SELECTORS.trigger)],
      contents: [...this.$component.querySelectorAll(this.SELECTORS.content)],
    };
  }

  handleTabClick() {
    this.dom.triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const targetTab = trigger.dataset.trigger;
        this.dom.triggers.forEach(t => t.classList.remove(this.CLASSES.active));
        trigger.classList.add(this.CLASSES.active);
        this.dom.contents.forEach(content => {
          if (content.dataset.tab === targetTab) {
            content.classList.remove(this.CLASSES.hidden);
          } else {
            content.classList.add(this.CLASSES.hidden);
          }
        });
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.$emit(this.$customEvents.PRODUCT_EVENTS.pdptabswitch);
        }
      });
    });
  }

  bindEvents() {
    this.handleTabClick();
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
